<template>
  <div class="mobile-price" @click="handleExpandOffer">
    <div class="backdrop" v-if="isLoading" />
    <div class="mobile-price-top">
      <div class="price-circle">
        <div
          v-if="isLoading"
          class="form__loader--mobile form__loader--loading"
        >
          <div class="mobile-price__spinner"><span></span></div>
        </div>
        <template v-else>
          <span class="price"
            >{{
              !discountCodeMatch
                ? panel.pris - panel.enovaStotte
                : (panel.pris - panel.enovaStotte - discount) | Thousands
            }},-</span
          >
          <i
            v-if="expandable"
            class="material-icons"
            :class="{ 'rotate-down': isOfferExpanded }"
            >expand_more</i
          >
        </template>
      </div>
    </div>
    <div
      v-if="expandable"
      class="mobile-price-information"
      :class="{ hidden: !isOfferExpanded }"
    >
      <OfferInformation></OfferInformation>
      <ProductionInformation style="margin: 2.1rem 0"></ProductionInformation>
    </div>
  </div>
</template>

<script>
import store from '../store';
import Thousands from '../../common/filters/Thousands';

import OfferInformation from '../components/OfferInformation';
import ProductionInformation from '../components/ProductionInformation';

export default {
  name: 'MobilePriceDrilldown',
  props: {
    expandable: Boolean,
  },
  filters: {
    Thousands,
  },
  components: {
    OfferInformation,
    ProductionInformation,
  },
  data() {
    return {
      discountCode: store.state.discountCode,
      isOfferExpanded: false,
    };
  },
  methods: {
    handleExpandOffer() {
      if (!this.isLoading) {
        this.isOfferExpanded = !this.isOfferExpanded;
      }
    },
  },
  computed: {
    discountCodeMatch() {
      return (
        this.discountCodeUserInput.trim().toLowerCase() === this.discountCode
      );
    },
    discountCodeUserInput() {
      return store.state.discountCodeUserInput;
    },
    isLoading() {
      return store.state.isLoading;
    },
    loadingText() {
      return store.state.loadingText;
    },
    panel() {
      return store.state.panelsVal;
    },
  },
};
</script>

<style scoped>
.mobile-price {
  background-color: #003451;
  height: 6rem;
  position: fixed;
  top: 5.5rem;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 15px 15px 0 rgba(0, 0, 0, 0.4);
  z-index: 1;
  visibility: hidden;
}

@media (max-width: 47.99em) {
  .mobile-price {
    visibility: visible;
  }
}

.mobile-price .mobile-price-top {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 6rem;
}

.mobile-price .mobile-price-top .price-circle {
  color: #fff;
  border: 0.2rem solid #fff;
  border-radius: 50%;
  height: 5rem;
  width: 5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  text-align: center;
  position: relative;
}

.mobile-price .mobile-price-top .price-circle .price {
  position: relative;
  top: 0.1rem;
  font-weight: 600;
}

.mobile-price .mobile-price-top .price-circle i {
  position: absolute;
  bottom: 0;
  font-size: 2.2rem;
  transition: all 0.5s linear;
}

.mobile-price .mobile-price-top .price-circle i.rotate-down {
  transform: rotate(180deg);
}

@keyframes bounce {
  0% {
    height: 0;
  }
  50% {
    height: 2rem;
  }
  100% {
    height: 0;
  }
}

.mobile-price .mobile-price-information {
  color: #fff;
  background-color: #003451;
  position: absolute;
  left: 0;
  right: 0;
  top: 6rem;
  padding: 0 2rem;
  z-index: 1;
  box-shadow: 0 20px 15px 0 rgba(0, 0, 0, 0.4);
  transition: height 0.5s ease-out;
  height: 25rem;
  overflow: scroll;
  animation: 0.5s linear 0.5s 2 bounce;
}

.mobile-price .mobile-price-information.hidden {
  height: 0;
  transition: height 0.5s ease-out;
}

.form__loader {
  display: none;
}

.backdrop {
  position: fixed;
  top: calc(6rem + 90px);
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.9);
}

@keyframes lds-ripple {
  0% {
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0;
    left: 0;
    width: 95%;
    height: 95%;
    opacity: 0;
  }
}

.mobile-price__spinner {
  width: 75px;
  height: 75px;
  top: 50%;
  left: 50%;
  margin: 1px;
  transform: translate(-50%, -50%);
  position: absolute;
}

.mobile-price__spinner:before,
.mobile-price__spinner:after {
  content: '';
  display: block;
  position: absolute;
  border: 4px solid #fff;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 2s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}

.mobile-price__spinner:after {
  animation-delay: -1s;
}

.mobile-price__spinner span {
  font-size: 1.1em;
  color: #cbd2d4;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 100%);
  text-align: center;
}
</style>
